export default "__VITE_ASSET__9e10d725__"